import { RootState } from '../../RootState';
import { StateSettings } from '../SettingsState';
import selectRequiredSettings from './selectRequiredSettings';

const selectCountryCode = (state: RootState): string => {
  const settings: StateSettings = selectRequiredSettings(state);
  return settings.countryCode;
};

export default selectCountryCode;
